export function getArrayFromParams(key) {
  const v = new URLSearchParams(window.location.search).get(key);

  if (v === null || v.length === 0) return [];

  return v.split(",");
}
